(function () {
  'use strict';

  var racine = document.getElementById('cm-mixf');
  if (!racine) return;

  function lire(nom) {
    var el = racine.querySelector('[' + nom + ']');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  var bonbons = lire('data-cm-mixf-bonbons');
  var variantes = lire('data-cm-mixf-variantes');
  var familles = lire('data-cm-mixf-familles');
  var regimes = lire('data-cm-mixf-regimes');

  var PAS = parseInt(racine.dataset.pas, 10) || 100;
  var VARIETES_MIN = parseInt(racine.dataset.varietesMin, 10) || 1;
  var TEXTE_BOUTON = racine.dataset.texteBouton || 'Ajouter au panier';

  var etat = {
    varianteId: parseInt(racine.dataset.variante, 10) || (variantes[0] && variantes[0].id),
    choix: {},
    ordre: [],
    filtre: 'tout',
    recherche: '',
    envoi: false,
  };

  var el = {
    sous: racine.querySelector('[data-cm-mixf-sous]'),
    grille: racine.querySelector('[data-cm-mixf-grille]'),
    aucun: racine.querySelector('[data-cm-mixf-aucun]'),
    filtres: racine.querySelector('[data-cm-mixf-filtres]'),
    tailles: racine.querySelector('[data-cm-mixf-tailles-liste]'),
    recherche: racine.querySelector('[data-cm-mixf-recherche]'),
    varietes: racine.querySelector('[data-cm-mixf-varietes]'),
    poids: racine.querySelector('[data-cm-mixf-poids]'),
    portions: racine.querySelector('[data-cm-mixf-portions]'),
    jauge: racine.querySelector('[data-cm-mixf-jauge]'),
    liste: racine.querySelector('[data-cm-mixf-liste]'),

    videsel: racine.querySelector('.cm-mixf__videsel'),
    ajouter: racine.querySelector('[data-cm-mixf-ajouter]'),
    erreur: racine.querySelector('[data-cm-mixf-erreur]'),
    barre: racine.querySelector('[data-cm-mixf-barre]'),
  };

  function varianteCourante() {
    for (var i = 0; i < variantes.length; i++) {
      if (variantes[i].id === etat.varianteId) return variantes[i];
    }
    return variantes[0] || null;
  }

  function quota() {
    var v = varianteCourante();
    if (!v || !v.grammes) return 0;
    return Math.max(0, Math.round(v.grammes / PAS));
  }

  function noter(id) {
    if (etat.ordre.indexOf(String(id)) === -1) etat.ordre.push(String(id));
  }

  function oublier(id) {
    var i = etat.ordre.indexOf(String(id));
    if (i !== -1) etat.ordre.splice(i, 1);
  }

  function ordreChoix() {
    return etat.ordre.filter(function (id) {
      return etat.choix[id];
    });
  }

  function prises() {
    var n = 0;
    for (var id in etat.choix) n += etat.choix[id];
    return n;
  }

  function varietes() {
    return Object.keys(etat.choix).length;
  }

  function restantes() {
    return Math.max(0, quota() - prises());
  }

  function poidsTexte(grammes) {
    if (grammes >= 1000) return (grammes / 1000).toString().replace('.', ',') + ' kg';
    return grammes + ' g';
  }

  function construireFiltres() {
    if (!el.filtres) return;
    var REGIME_IMPOSE = racine.dataset.regimeImpose || '';
    var html = '<button type="button" class="cm-mixf__filtre" data-valeur="tout">Tout</button>';
    familles.forEach(function (f) {
      if (!f.libelle) return;
      html += '<button type="button" class="cm-mixf__filtre" data-valeur="f:' + f.id + '">' + echapper(f.libelle) + '</button>';
    });
    regimes.forEach(function (r) {
      if (!r.libelle) return;

      if (REGIME_IMPOSE && r.id === REGIME_IMPOSE) return;
      html += '<button type="button" class="cm-mixf__filtre" data-valeur="r:' + r.id + '">' +
        (r.emoji ? echapper(r.emoji) + ' ' : '') + echapper(r.libelle) + '</button>';
    });
    el.filtres.innerHTML = html;
    majFiltres();
  }

  function majFiltres() {
    if (!el.filtres) return;
    el.filtres.querySelectorAll('.cm-mixf__filtre').forEach(function (b) {
      var actif = b.dataset.valeur === etat.filtre;
      b.classList.toggle('is-actif', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
  }

  function construireTailles() {
    if (!el.tailles) return;
    var html = '';
    variantes.forEach(function (v) {
      var portions = v.grammes ? Math.round(v.grammes / PAS) : 0;
      var classes = 'cm-mixf__taille';
      if (v.id === etat.varianteId) classes += ' is-actif';
      if (!v.dispo) classes += ' is-epuise';
      html += '<button type="button" class="' + classes + '" data-taille="' + v.id + '"' +
        ' aria-pressed="' + (v.id === etat.varianteId ? 'true' : 'false') + '">' +
        '<span class="cm-mixf__taille-nom">' + echapper(v.titre) + '</span>' +
        (portions ? '<span class="cm-mixf__taille-detail">' + portions + ' portions</span>' : '') +
        (v.dispo ? '' : '<span class="cm-mixf__taille-detail">épuisé</span>') +
        '</button>';
    });
    el.tailles.innerHTML = html;
  }

  function tenirLaPosition(y, duree) {
    var fin = Date.now() + (duree || 800);
    var abandon = false;
    var signaux = ['wheel', 'touchmove', 'keydown'];

    function renoncer() {
      abandon = true;
    }

    function liberer() {
      signaux.forEach(function (nom) {
        window.removeEventListener(nom, renoncer);
      });
    }

    signaux.forEach(function (nom) {
      window.addEventListener(nom, renoncer, { passive: true });
    });

    (function tenir() {
      if (abandon) return liberer();
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
      if (Date.now() < fin) requestAnimationFrame(tenir);
      else liberer();
    })();
  }

  function focusSansDefilement(duree) {
    if (window.__cmMixfFocus) return;
    var natif = HTMLElement.prototype.focus;
    window.__cmMixfFocus = true;
    HTMLElement.prototype.focus = function (options) {
      var o = options || {};
      o.preventScroll = true;
      return natif.call(this, o);
    };
    setTimeout(function () {
      HTMLElement.prototype.focus = natif;
      window.__cmMixfFocus = false;
    }, duree || 900);
  }

  function choisirTaille(id) {
    var radio = document.querySelector('.js-option[data-variant-id="' + id + '"]');
    if (radio) {

      var position = window.scrollY;
      focusSansDefilement(900);
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      tenirLaPosition(position, 900);
      return;
    }
    etat.varianteId = parseInt(id, 10);
    rognerSiTropGrand();
    tout();
  }

  function sansAccents(texte) {
    return (texte || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function echapper(texte) {
    return String(texte == null ? '' : texte)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function visibles() {
    var recherche = sansAccents(etat.recherche).trim();
    return bonbons.filter(function (b) {
      if (etat.filtre !== 'tout') {
        var genre = etat.filtre.slice(0, 1);
        var id = etat.filtre.slice(2);
        var appartient = genre === 'f' ? (b.familles || []) : (b.regles || []);
        if (appartient.indexOf(id) === -1) return false;
      }
      if (recherche && sansAccents(b.titre).indexOf(recherche) === -1) return false;
      return true;
    });
  }

  function pastilles(b) {
    var html = '';
    (b.regles || []).forEach(function (id) {
      for (var i = 0; i < regimes.length; i++) {
        if (regimes[i].id !== id || !regimes[i].libelle) continue;

        html += '<span class="cm-mixf__pastille" data-r="' + echapper(regimes[i].id) + '">' +
          (regimes[i].emoji ? echapper(regimes[i].emoji) + ' ' : '') +
          echapper(regimes[i].libelle) + '</span>';
      }
    });
    return html;
  }

  function construireGrille() {
    var liste = visibles();
    var plein = restantes() === 0;
    var html = '';

    liste.forEach(function (b) {
      var n = etat.choix[b.id] || 0;

      var rupture = b.dispo === false;
      var classes = 'cm-mixf__carte';
      if (rupture) classes += ' is-rupture';
      else if (n > 0) classes += ' is-choisi';
      else if (plein) classes += ' is-eteint';

      html += '<li class="' + classes + '" data-id="' + b.id + '">';
      html += '<button type="button" class="cm-mixf__vignette" data-ajouter="' + b.id + '"' +
        (rupture || (n === 0 && plein) ? ' disabled' : '') +
        ' aria-label="' + (rupture ? echapper(b.titre) + ' — rupture de stock'
                                   : 'Ajouter une portion de ' + echapper(b.titre)) + '">';
      if (b.image) {
        html += '<img src="' + echapper(b.image) + '" alt="" loading="lazy" decoding="async" width="240" height="240">';
      } else {
        html += '<span class="cm-mixf__sansimage" aria-hidden="true">🍬</span>';
      }
      if (n > 0) html += '<span class="cm-mixf__compteur">' + n + '</span>';
      html += '</button>';

      html += '<p class="cm-mixf__nom">' + echapper(b.titre) + '</p>';
      var p = pastilles(b);
      if (p) html += '<p class="cm-mixf__pastilles">' + p + '</p>';

      if (n > 0) {
        html += '<div class="cm-mixf__qte">' +
          '<button type="button" data-retirer="' + b.id + '" aria-label="Retirer une portion">−</button>' +
          '<span>' + n + '</span>' +
          '<button type="button" data-ajouter="' + b.id + '" aria-label="Ajouter une portion"' + (plein ? ' disabled' : '') + '>+</button>' +
          '</div>';
      } else if (rupture) {
        html += '<p class="cm-mixf__invite cm-mixf__rupture">Rupture de stock</p>';
      } else {
        html += '<p class="cm-mixf__invite">' + (plein ? 'Quota atteint' : 'Touche pour ajouter') + '</p>';
      }

      html += '</li>';
    });

    el.grille.innerHTML = html;
    el.aucun.hidden = liste.length > 0;
  }

  function emojiRegime(b) {
    var regles = b.regles || [];
    for (var i = 0; i < regimes.length; i++) {
      if (regles.indexOf(regimes[i].id) !== -1 && regimes[i].emoji) return regimes[i].emoji;
    }
    return '';
  }

  function construireListe() {
    if (!el.liste) return;
    var ids = ordreChoix();
    var html = '';

    ids.forEach(function (id) {
      var b = parBonbon(id);
      if (!b) return;
      var emoji = emojiRegime(b);
      html += '<li class="cm-mixf__ligne">';
      if (b.image) {
        html += '<img src="' + echapper(b.image) + '" alt="" loading="lazy" decoding="async" width="88" height="88">';
      } else {
        html += '<span class="cm-mixf__ligne-sansimage" aria-hidden="true">\uD83C\uDF6C</span>';
      }
      html += '<span class="cm-mixf__ligne-nom">' +
        (emoji ? echapper(emoji) + ' ' : '') + echapper(b.titre) + '</span>';
      html += '<span class="cm-mixf__ligne-qte">\u00D7' + etat.choix[id] + '</span>';
      html += '<button type="button" class="cm-mixf__ligne-x" data-supprimer="' + b.id +
        '" aria-label="Retirer ' + echapper(b.titre) + ' du mix">\u00D7</button>';
      html += '</li>';
    });

    el.liste.innerHTML = html;
    if (el.videsel) el.videsel.hidden = ids.length === 0;
  }

  function construirePanneau() {
    var q = quota();
    var n = prises();
    var v = varietes();
    var grammes = n * PAS;

    el.varietes.textContent = v > 0 ? '· ' + v + (v > 1 ? ' différents' : ' bonbon') : '';
    el.poids.textContent = grammes;
    el.portions.textContent = n + ' / ' + q;
    el.jauge.style.width = q > 0 ? Math.min(100, Math.round((n / q) * 100)) + '%' : '0%';

    var variante = varianteCourante();
    var pret = q > 0 && n === q && v >= VARIETES_MIN && variante && variante.dispo;
    el.ajouter.disabled = !pret || etat.envoi;

    if (etat.envoi) {
      el.ajouter.textContent = 'Ajout en cours…';
    } else if (q === 0) {
      el.ajouter.textContent = 'Choisis un poids';
    } else if (n < q) {
      var r = q - n;
      el.ajouter.textContent = r + (r > 1 ? ' portions restantes' : ' portion restante');
    } else if (v < VARIETES_MIN) {
      el.ajouter.textContent = VARIETES_MIN + ' bonbons différents minimum';
    } else if (variante && !variante.dispo) {
      el.ajouter.textContent = 'Poids épuisé';
    } else {
      el.ajouter.textContent = TEXTE_BOUTON + ' · ' + poidsTexte(grammes);
    }

    el.barre.classList.toggle('is-actif', n > 0);
  }

  function construireSousTitre() {
    var q = quota();
    var v = varianteCourante();
    if (!q) {
      el.sous.textContent = 'Choisissez d’abord un poids, en bas de la fiche.';
      return;
    }

    var kilos = String((q * PAS) / 1000);
    el.sous.textContent =
      'Répartissez ' + q + ' portion' + (q > 1 ? 's' : '') + ' (' + kilos + ' kg)' +
      ' — minimum ' + VARIETES_MIN + ' produit' + (VARIETES_MIN > 1 ? 's différents' : ' différent') +
      (v && !v.dispo ? ' — ce poids est épuisé pour le moment' : '');
  }

  function parBonbon(id) {
    for (var i = 0; i < bonbons.length; i++) {
      if (String(bonbons[i].id) === String(id)) return bonbons[i];
    }
    return null;
  }

  function tout() {
    construireSousTitre();
    construireTailles();
    construireGrille();
    construireListe();
    construirePanneau();
  }

  function rognerSiTropGrand() {
    var q = quota();
    while (prises() > q) {
      var cles = ordreChoix();
      retirerSilencieux(cles[cles.length - 1]);
    }
  }

  function achetable(b) {
    return b && b.dispo !== false;
  }

  function ajouter(id) {
    if (restantes() <= 0) return;

    if (!achetable(parBonbon(id))) return;
    etat.choix[id] = (etat.choix[id] || 0) + 1;
    noter(id);
    tout();
  }

  function retirer(id) {
    if (!etat.choix[id]) return;
    etat.choix[id] -= 1;
    if (etat.choix[id] <= 0) {
      delete etat.choix[id];
      oublier(id);
    }
    tout();
  }

  function supprimer(id) {
    delete etat.choix[id];
    oublier(id);
    tout();
  }

  function surprise() {

    var dispo = visibles().filter(achetable);
    if (!dispo.length) return;
    var boucle = 0;
    while (restantes() > 0 && boucle < 500) {
      var b = dispo[Math.floor(Math.random() * dispo.length)];
      etat.choix[b.id] = (etat.choix[b.id] || 0) + 1;
      noter(b.id);
      boucle++;
    }
    tout();
  }

  function toutSelectionner() {
    var ajoutes = 0;
    var ignores = 0;

    visibles().filter(achetable).forEach(function (b) {
      if (etat.choix[b.id]) return;
      if (restantes() <= 0) { ignores += 1; return; }
      etat.choix[b.id] = 1;
      noter(b.id);
      ajoutes += 1;
    });

    tout();

    if (!el.erreur) return;
    if (ignores > 0) {
      el.erreur.textContent =
        ajoutes + (ajoutes > 1 ? ' bonbons ajoutés' : ' bonbon ajouté') +
        ' — ce format ne tient que ' + quota() +
        ' portions. Affine ta recherche, ou choisis un plus grand format.';
      el.erreur.hidden = false;
    } else {
      el.erreur.hidden = true;
    }
  }

  function vider() {
    etat.choix = {};
    etat.ordre = [];
    tout();
  }

  function proprietes() {
    var props = {};
    props['Mix total'] = poidsTexte(prises() * PAS);
    var detail = [];
    ordreChoix().forEach(function (id) {
      var b = parBonbon(id);
      if (!b) return;
      props[b.titre] = etat.choix[id] + ' × ' + PAS + ' g';
      detail.push({ id: b.id, titre: b.titre, portions: etat.choix[id] });
    });

    props._composition = JSON.stringify(detail);
    return props;
  }

  function auPanier() {
    if (el.ajouter.disabled) return;
    etat.envoi = true;
    el.erreur.hidden = true;
    construirePanneau();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: etat.varianteId, quantity: 1, properties: proprietes() }],
      }),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, donnees: d };
        });
      })
      .then(function (reponse) {
        etat.envoi = false;
        if (!reponse.ok) {
          el.erreur.textContent = reponse.donnees.description || reponse.donnees.message || 'Ajout impossible.';
          el.erreur.hidden = false;
          construirePanneau();
          return;
        }
        vider();
        document.dispatchEvent(
          new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: etat.varianteId } })
        );

        var icone = document.getElementById('cart-icon');
        if (icone) icone.click();
      })
      .catch(function () {
        etat.envoi = false;
        el.erreur.textContent = 'Ajout impossible pour le moment.';
        el.erreur.hidden = false;
        construirePanneau();
      });
  }

  racine.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ajouter], [data-retirer], [data-supprimer], [data-taille], [data-cm-mixf-surprise], [data-cm-mixf-tout], [data-cm-mixf-vider], [data-cm-mixf-ajouter], .cm-mixf__filtre');
    if (!b) return;

    if (b.dataset.taille) return choisirTaille(b.dataset.taille);
    if (b.dataset.ajouter) return ajouter(b.dataset.ajouter);
    if (b.dataset.retirer) return retirer(b.dataset.retirer);
    if (b.dataset.supprimer) return supprimer(b.dataset.supprimer);
    if (b.hasAttribute('data-cm-mixf-surprise')) return surprise();
    if (b.hasAttribute('data-cm-mixf-tout')) return toutSelectionner();
    if (b.hasAttribute('data-cm-mixf-vider')) return vider();
    if (b.hasAttribute('data-cm-mixf-ajouter')) return auPanier();
    if (b.classList.contains('cm-mixf__filtre')) {
      etat.filtre = b.dataset.valeur;
      majFiltres();
      construireGrille();
    }
  });

  racine.addEventListener('mousedown', function (e) {
    var b = e.target.closest('[data-taille], .cm-mixf__vignette, [data-ajouter], [data-retirer], [data-supprimer], [data-cm-mixf-tout], [data-cm-mixf-vider], [data-cm-mixf-surprise]');
    if (!b) return;
    e.preventDefault();
    b.focus({ preventScroll: true });
  });
  var minuteur = null;
  el.recherche.addEventListener('input', function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () {
      etat.recherche = el.recherche.value;
      construireGrille();
    }, 180);
  });

  document.addEventListener('on:variant:change', function (e) {
    var id = e.detail && e.detail.variant && e.detail.variant.id;
    if (!id) return;
    etat.varianteId = id;

    rognerSiTropGrand();
    tout();

    placerLePoids();
  });

  document.addEventListener(
    'pointerdown',
    function (e) {
      var cible = e.target;
      if (!cible || !cible.closest || !cible.closest('.product-options')) return;
      focusSansDefilement(1200);
      tenirLaPosition(window.scrollY, 1200);
    },
    true
  );

  function retirerSilencieux(id) {
    if (!etat.choix[id]) return;
    etat.choix[id] -= 1;
    if (etat.choix[id] <= 0) {
      delete etat.choix[id];
      oublier(id);
    }
  }

  var champ = document.querySelector('.product-info [name="id"], form[action*="/cart/add"] [name="id"]');
  if (champ && champ.value) {
    var id = parseInt(champ.value, 10);
    if (id) etat.varianteId = id;
  }

  function placerDansColonne() {
    var colonne = document.querySelector('.product-info__sticky') || document.querySelector('.product-info');
    if (!colonne || colonne.contains(racine)) return;

    var apres =
      colonne.querySelector('.product-info__block.product-options') ||
      colonne.querySelector('.product-info__block.product-price') ||
      colonne.querySelector('.product-info__block');

    var enveloppe = document.createElement('div');
    enveloppe.className = 'product-info__block cm-mixf__bloc';
    racine.classList.add('cm-mixf--colonne');
    enveloppe.appendChild(racine);

    if (apres && apres.parentElement === colonne) {
      apres.insertAdjacentElement('afterend', enveloppe);
    } else {
      colonne.appendChild(enveloppe);
    }
  }

  function placerLesDetails() {
    if (racine.dataset.deplacerDetails !== 'oui') return;
    var media = document.getElementById('product-media');
    var details = document.querySelector('.cc-product-details');
    if (!media || !details || media.contains(details)) return;
    details.classList.add('cm-mixf__details');
    media.appendChild(details);
  }

  function colonneInfos() {
    return document.querySelector('.product-info__sticky') || document.querySelector('.product-info');
  }

  function placerLePoids() {
    var colonne = colonneInfos();
    if (!colonne) return;

    colonne.classList.add('cm-mixf__colonne');

    var options = colonne.querySelector(':scope > .product-info__block.product-options');
    if (!options) return;

    var reappro = colonne.querySelector(':scope > .product-info__block.product-backorder');

    var dernier = reappro || options;
    if (colonne.lastElementChild === dernier) return;

    colonne.appendChild(options);
    if (reappro) colonne.appendChild(reappro);
  }

  placerDansColonne();
  placerLePoids();
  placerLesDetails();

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entrees) {
        entrees.forEach(function (e) {
          el.barre.classList.toggle('is-visible', e.isIntersecting);
        });
      },
      { rootMargin: '-120px 0px -10% 0px' }
    ).observe(racine);
  } else {
    el.barre.classList.add('is-visible');
  }

  construireFiltres();
  tout();
})();
